import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { extractStatusCode } from 'common/services/api/apiHelpers';
import { fetchUserProfilesByEmail } from 'common/services/api/UserProfiles/UserProfiles.thunk';
import { UserProfileOemMapping } from 'common/types/Entities';

import type { RootState } from '../../../../app/store';

type UserProfilesSliceState = {
    userProfiles: UserProfileOemMapping[];
    processing: boolean;
    errorCode?: number;
};

const initialState: UserProfilesSliceState = {
    userProfiles: [],
    processing: false
};

const userProfilesSlice = createSlice({
    name: 'userProfiles',
    initialState,

    reducers: (create) => ({
        clearUserProfiles: create.reducer((state) => {
            state.userProfiles = [];
        })
    }),

    extraReducers: builder => {
        builder.addCase(fetchUserProfilesByEmail.pending, state => {
            state.processing = true;
            state.userProfiles = [];
        });
        builder.addCase(fetchUserProfilesByEmail.fulfilled, (state, action: PayloadAction<UserProfileOemMapping[]>) => {
            state.processing = false;
            state.userProfiles = action.payload;
        });
        builder.addCase(fetchUserProfilesByEmail.rejected, (state, error) => {
            state.processing = false;
            state.errorCode = extractStatusCode(error.error.message ?? '');
            state.userProfiles = [];
        });
    }
});

// eslint-disable-next-line no-restricted-syntax
export default userProfilesSlice.reducer;
export const { clearUserProfiles } = userProfilesSlice.actions;
export const selectUserProfiles = (state: RootState) => state.userProfiles.userProfiles;
